/******Contact******/

/*PAGE*/
export default function Contact() {
  /*DOM*/
  return (
    <div className="homepage realisations partenaires Contact">
      <h1>Contact</h1>

      <div className="mainText ">
        <div className="mainLeft">
          <p>
            <strong>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
              aliquam dolor vel nisi fermentum, in scelerisque nisi volutpat.
            </strong>
            .
            <br />
            <br />
            Morbi ultrices sapien a ex maximus, vitae malesuada velit hendrerit.
            Ut lectus felis, viverra non sollicitudin sed, ornare sed quam.
            Phasellus nisl augue, condimentum ac egestas sit amet, iaculis vitae
            justo. In efficitur in quam pulvinar hendrerit. Maecenas elementum
            congue ligula, accumsan luctus velit posuere ac. Nulla convallis
            libero gravida, ornare mauris eget, laoreet urna. Orci varius
            natoque penatibus et magnis dis parturient montes, nascetur
            ridiculus mus. Etiam cursus, sapien sed sodales molestie, turpis est
            dignissim neque, eget egestas diam erat eget ex.
          </p>
        </div>
        <div className="mainRight">
          <img
            fetchpriority="high"
            src="/img/logo.webp"
            className="logoContact"
            alt="illustration du projet UNANÎMES"
          />
        </div>
      </div>
      <a className="contactButton" href="mailto:xavier.moulin@unimes.fr">
        <p>Nous contacter</p>
      </a>

      <div className="mainText mainText2">
        <div className="mainLeft">
          <h2>Les acteurs du projet</h2>
          <p>
            <strong> </strong>
            Morbi ultrices sapien a ex maximus, vitae malesuada velit hendrerit.
            Ut lectus felis, viverra non sollicitudin sed, ornare sed quam.
            Phasellus nisl augue, condimentum ac egestas sit amet, iaculis vitae
            justo. In efficitur in quam pulvinar hendrerit. Maecenas elementum
            congue ligula, accumsan luctus velit posuere ac. Nulla convallis
            libero gravida, ornare mauris eget, laoreet urna. Orci varius
            natoque penatibus et magnis dis parturient montes, nascetur
            ridiculus mus. Etiam cursus, sapien sed sodales molestie, turpis est
            dignissim neque, eget egestas diam erat eget ex.
          </p>
        </div>

        <div className="mainRight">
          <img
            fetchpriority="high"
            src="/img/acteurs.webp"
            className="logo"
            alt="illustration du projet UNANÎMES"
          />
        </div>
      </div>
    </div>
  );
}
